export class AssignedDetailsForFile {
  assignedTo: string;
  type: string;
  ownerId: string;
  lastOpened: string;
  by: string;
  linkId: number;
}